import { PartialType } from '../../../utils';
import { CreateVendorAuthorityDto } from './create-vendor-authority.dto';
export class UpdateVendorAuthorityDto extends PartialType(CreateVendorAuthorityDto) {
}
